import React from 'react'
import PrivateRoutes from './PrivateRoutes'
import { Route, Routes } from 'react-router-dom'
import LoginPage from '../PublicPages/LoginPage'
import PrivateRoutList from './PrivateRoutList'
import MainLayout from '../Layout/MainLayout'
import HomePage from '../ProtectPages/AdminPanel/homePage'


const RouteManager = () => {


return (
  <div>
    
      <Routes>
      <Route element={<PrivateRoutes />}>
          <Route path='Dashboard'  element={<MainLayout/>}>
         <Route path='Home/:key' element={<HomePage/>}></Route>
         <Route path='Home' element={<HomePage/>}></Route>
          {PrivateRoutList&&PrivateRoutList.map((route, index) => (
              <Route key={index} path={route.path} element={route.element}>
                  {route.children && route.children.map((child, idx) => (
                      <Route key={idx} path={child.path} element={child.element} >
                      </Route>
                  ))}
              </Route>
          ))}</Route>
          </Route>
          
        
       
            <Route path='login' element={<LoginPage/>}></Route>
            <Route element={<LoginPage/>} path="*" />
  
      </Routes>
     
  </div>
)
 
}

export default RouteManager